import { render, staticRenderFns } from "./DashboardAssetsCount.vue?vue&type=template&id=7b63ac98&scoped=true"
import script from "./DashboardAssetsCount.vue?vue&type=script&lang=js"
export * from "./DashboardAssetsCount.vue?vue&type=script&lang=js"
import style0 from "./DashboardAssetsCount.vue?vue&type=style&index=0&id=7b63ac98&prod&lang=scss&scoped=true"
import style1 from "./DashboardAssetsCount.vue?vue&type=style&index=1&id=7b63ac98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b63ac98",
  null
  
)

export default component.exports